(function() {
  const header = document.querySelector('.header');
  const headerSection = document.querySelector('.headerSection');
  const overlayArray = document.querySelectorAll('.popupVideo__overlay');
  const body = document.querySelector('body');
  const popUp = document.querySelector('.popupVideo__content');
  const button = document.querySelector('.popupVideo__contentButton');
  const video = document.querySelector('.popupVideo__contentVideo');
  const desktopVideo = document.querySelector('.popupVideo__contentVideo--desktop');
  const mobileVideo = document.querySelector('.popupVideo__contentVideo--mobile');

  headerSection.style.marginTop = `${document.querySelector('.noticeList').scrollHeight}px`;

  function toggleHeaderModule() {
    if (window.pageYOffset < 1) {
      header.classList.add('header--split');
    } else {
      header.classList.remove('header--split');
    }
  }

  function openPopUp() {
    popUp.classList.add('popupVideo__content--open');
    body.classList.add('body--overflow');

    if (desktopVideo && mobileVideo) {
      if (window.innerWidth >= 768) {
        desktopVideo.play();
      } else {
        mobileVideo.play();
      }
    } else {
      video.play();
    }
  }

  function closePopup() {
    popUp.classList.remove('popupVideo__content--open');
    body.classList.remove('body--overflow');

    if (desktopVideo && mobileVideo) {
      if (window.innerWidth >= 768) {
        desktopVideo.pause();
      } else {
        mobileVideo.pause();
      }
    } else {
      video.pause();
    }
  }

  toggleHeaderModule();

  window.addEventListener('scroll', toggleHeaderModule);
  button.addEventListener('click', closePopup);

  overlayArray.forEach(overlay => {
    overlay.addEventListener('click', (e) => {
      e.preventDefault();
      openPopUp();
    });
  });
}());
